export default __webpack_public_path__ + "static/media/artGallery.f0983d49.png";